<template>
  <ul class="form__steps">
    <li class="form__step" v-for="item in stepMessage" v-html="item.message" :key="item.key"></li>
  </ul>
</template>
<script>
  export default {
    name: 'FormSteps',
    data() {
      return {
        stepMessage: [
          {
            message: 'Изучите&nbsp; <a href="/e-commerce/dokumenty/dokumenty-i-tarify#dogovory">оферту Boxberry&nbsp;</a>и&nbsp;тарифы',
            key: 'firstStep',
          },
          {
            message: 'Заполните информацию о&nbsp;своей компании после регистрации',
            key: 'secondStep',
          },
          {
            message: 'При необходимости наш менеджер свяжется с&nbsp;вами, чтобы&nbsp;уточнить данные',
            key: 'thirdStep',
          },
          {
            message: 'Если возникли вопросы задайте их&nbsp;через службу поддержки в&nbsp;Личном кабинете или&nbsp;на&nbsp;сайте',
            key: 'fourStep',
          },
        ]
      }
    }
  }
</script>
